/* LAYDOWN 177: animate the native banner without delaying consent actions. */
(() => {
  if (window.__laydownCookieMotion) return;
  window.__laydownCookieMotion = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timing = { duration: 460, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' };
  let banner = null;
  let snapshot = null;
  let entry = null;
  let visible = false;
  let attributeObserver = null;

  const isVisible = (node) => node?.isConnected && !node.hidden &&
    getComputedStyle(node).display !== 'none' &&
    getComputedStyle(node).visibility !== 'hidden' && node.getBoundingClientRect().height > 0;

  const capture = () => {
    if (!isVisible(banner) || reduced.matches) return;
    const rect = banner.getBoundingClientRect();
    const copy = banner.cloneNode(true);
    const originals = [banner, ...banner.querySelectorAll('*')];
    const copies = [copy, ...copy.querySelectorAll('*')];
    originals.forEach((node, index) => {
      const style = getComputedStyle(node);
      for (const name of style) copies[index].style.setProperty(name, style.getPropertyValue(name));
      copies[index].removeAttribute('id');
      copies[index].removeAttribute('autofocus');
    });
    copy.setAttribute('aria-hidden', 'true');
    copy.removeAttribute('role');
    copy.inert = true;
    copy.dataset.laydownCookieExit = '';
    Object.assign(copy.style, {
      position: 'fixed', left: `${rect.left}px`, top: `${rect.top}px`,
      right: 'auto', bottom: 'auto', width: `${rect.width}px`, height: `${rect.height}px`,
      boxSizing: 'border-box', margin: '0', transform: 'none',
      pointerEvents: 'none', transition: 'none', animation: 'none'
    });
    snapshot = { copy, distance: window.innerHeight - rect.top + 24 };
  };

  const enter = () => {
    visible = true;
    snapshot = null;
    if (reduced.matches || !banner.animate) return;
    const rect = banner.getBoundingClientRect();
    const target = banner;
    entry = target.animate([
      { transform: `translateY(${window.innerHeight - rect.top + 24}px)` },
      { transform: 'translateY(0)' }
    ], timing);
    entry.finished.then(() => {
      if (banner === target && visible) capture();
    }).catch(() => {});
  };

  const leave = () => {
    visible = false;
    entry?.cancel();
    entry = null;
    const saved = snapshot;
    snapshot = null;
    if (!saved || reduced.matches) return;
    document.body.appendChild(saved.copy);
    const animation = saved.copy.animate([
      { transform: 'translateY(0)' },
      { transform: `translateY(${saved.distance}px)` }
    ], { duration: 380, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' });
    animation.finished.finally(() => saved.copy.remove());
  };

  const refresh = () => {
    const next = document.getElementById('shopify-pc__banner');
    if (next !== banner) {
      if (visible) leave();
      attributeObserver?.disconnect();
      banner = next;
      if (banner) {
        attributeObserver = new MutationObserver(refresh);
        attributeObserver.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      }
    }
    const nowVisible = isVisible(banner);
    if (nowVisible && !visible) enter();
    else if (!nowVisible && visible) leave();
  };

  // Capture before Shopify's handlers remove/hide the original banner.
  document.addEventListener('click', (event) => {
    if (banner?.contains(event.target)) {
      entry?.cancel();
      entry = null;
      capture();
    }
  }, true);
  window.addEventListener('resize', capture);
  const start = () => {
    new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
    refresh();
  };
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
